import './GlobalStyles.module.scss';

const GlobalStyles: React.FC<any> = ({ children }) => {
    return (children);
}

export default GlobalStyles;
